export default function SearchForm(element, options = {}) {
    if (!element) {
        return;
    }

    const _form = element.querySelector('form');
    const _inputfield = element.querySelector(`input[type="search"]`);
    const _submitbutton = element.querySelector(`button[type="submit"]`);

    if (!_form || !_inputfield || !_submitbutton) {
        return;
    }
    
    // Add eventListeners:
    const changeEvents = ["change", "keyup", "focus", "blur"];
    changeEvents.forEach(changeEvent => _inputfield.addEventListener(changeEvent, () => {
        if (_inputfield.value !== undefined) {
            _submitbutton.removeAttribute("disabled");
        } else {
            _submitbutton.setAttribute("disabled", "disabled");
        }
    }));
    
    _form.addEventListener("submit", (e) => {
        if (_inputfield.value) {
            _submitbutton.focus();
            _submitbutton.setAttribute("disabled", "disabled");
        } else {
            e.preventDefault();
        }
    });

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            _submitbutton.disabled = false;
        }
    });
}